exports.faqData = [
  {
    question: "What is Cuisine compass?",
    ans: "Cuisine compass is simple restaurant management system developed by 7th sem students of patan multiple campus.",
  },
  {
    question: "Where is Cuisine compass?",
    ans: "Cuisine compass is a final year project. So, Patan Multiple Campus,patandhoka is it's current location.",
  },
  {
    question:
      "How can a restaurant register on the Cuisine?",
    ans: "To register a restaurant, navigate to the 'Business' page and select Plan on the Cuisine Compass website. Fill in the required information, including business details, menu, and contact information. Once submitted, the Cuisine team will review the application and approve it if it meets the criteria.",
  },
  {
    question:
      "How can users place orders through the Cuisine Compass?",
    ans: "Users can browse through the list of registered restaurants, view menus, and place orders directly through the Cuisine platform. The ordering process is user-friendly, allowing customers to customize their orders and make secure online payments.",
  },
  {
    question:
      "Is there a loyalty program for customers?",
    ans: "Yes, the Cuisine provides a loyalty program to encourage repeat business. Users can earn loyalty points with each order, which can be redeemed for discounts, free items, or other rewards.",
  },
  {
    question:
      "Can individuals apply for delivery jobs through the Cuisine?",
    ans: "Yes, the Cuisine offers a platform for individuals interested in delivery jobs. The 'Start Earning' section allows users to submit their applications. The Cuisine Compass team will review applications and contact potential candidates for further steps in the hiring process.",
  },
  {
    question:
      "Is there a support system for users and restaurant owners?",
    ans: "Yes, the Cuisine Compass provides customer support for both users and restaurant owners. ",
  },
];
